module.exports = __webpack_public_path__ + "static/media/cabelas.db7d324c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/where-to-buy/cabelas.jpg
// module id = 1310
// module chunks = 0